import { useMemo } from "react";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import {
  bannerLines,
  parseSteps,
  withDarwinFromTargets,
} from "@/lib/stepChecklist";

/** The attempt-level banner: every degraded / failed step with its reason,
 *  at the top of the attempt card so it cannot be missed. The step rows
 *  themselves are components/registry/PublishSteps.tsx (the 13-step view). */
export function StepProblemBanner({
  steps,
  nativeTargets,
  status,
}: {
  steps: unknown;
  nativeTargets: string | null | undefined;
  status?: string | null;
}) {
  const lines = useMemo(() => {
    const parsed = parseSteps(steps);
    return parsed
      ? bannerLines(withDarwinFromTargets(parsed, nativeTargets, status))
      : [];
  }, [steps, nativeTargets, status]);
  if (lines.length === 0) return null;
  const failed = lines.some((l) => / FAILED/.test(l));
  return (
    <Alert
      variant={failed ? "destructive" : "warning"}
      className="py-2"
      data-testid="step-banner"
    >
      <AlertTitle>
        {failed ? "Failed" : "Degraded"} optimisation or step in this run
      </AlertTitle>
      <AlertDescription>
        <ul className="list-disc pl-4 space-y-0.5 font-mono text-xs whitespace-pre-wrap break-words">
          {lines.map((l, i) => (
            <li key={i}>{l}</li>
          ))}
        </ul>
      </AlertDescription>
    </Alert>
  );
}
